import styled from 'styled-components'
interface IColumnProps {
  $flexBasis?: string | number
}

export const Container = styled.div`
  padding: 10px;
`
export const TitleItemServicoFinanceiro = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 38px;

  color: #2d3a40;
`
export const SubtitleItemServicoFinanceiro = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #6d787d;
`
